import { defaultDropAnimationSideEffects, DragEndEvent, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';
import { useMemo, useState } from 'react';

import { useDragEndHandler } from './useDragEndHandler';
import { isDraggableImageData, DraggableImageData } from '../../utils/typeGuards';

type DragState = {
  activeImage: DraggableImageData | null;
  isOverDropzone: boolean;
};

type UseImagesManagerDndProps = {
  venueId: string;
  token: string | null;
};

export const useImagesManagerDnd = ({ venueId, token }: UseImagesManagerDndProps) => {
  const [dragState, setDragState] = useState<DragState>({
    activeImage: null,
    isOverDropzone: false,
  });
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 1,
      },
    }),
  );

  const dropAnimation = useMemo(() => {
    return {
      duration: 200,
      sideEffects: defaultDropAnimationSideEffects({
        styles: { dragOverlay: { opacity: dragState.isOverDropzone ? '0' : '1' } },
      }),
    };
  }, [dragState.isOverDropzone]);

  const handleDragStart = (event: DragEndEvent) => {
    const image = event.active?.data.current;

    if (!isDraggableImageData(image)) {
      return;
    }

    setDragState(prevState => ({ ...prevState, activeImage: image }));
  };

  const handleDragEndEvent = useDragEndHandler({ venueId, token });
  const handleDragEnd = (event: DragEndEvent) => {
    setDragState({ activeImage: null, isOverDropzone: !!event.over?.data.current?.id });

    handleDragEndEvent(event);
  };

  return {
    dragState,
    sensors,
    dropAnimation,
    handleDragStart,
    handleDragEnd,
  };
};
